import Vue from 'vue'
import Router from 'vue-router'
import ReadMore from '@/components/ReadMore'
import PhotoGrid from '@/components/PhotoGrid'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      name: 'PhotoGrid',
      component: PhotoGrid,
      meta: {title: 'Photo Grid'}
    },
    {
      path: '/read-more',
      name: 'ReadMore',
      component: ReadMore,
      meta: {title: 'Read More'}
    }
  ]
})

// Router.beforeEach((to, from, next) => {
//   document.title = to.meta.title(to)
//   next()
// })


// WEBPACK FOOTER //
// ./src/router/index.js